export const environment = {
  production: true,
  buildId: '3858618092823651',
  configFile: 'config.json',
};
